<template>
  <div class="toggle-details v-toggle-details">
    <el-link
      class="details-button el-text--height-m el-text--weight-bold"
      @click="detailsVisible = !detailsVisible"
    >
      {{ detailsVisible ? translations.hideDetails : translations.showDetails }}
    </el-link>
    <div v-if="detailsVisible">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ToggleDetails',
    props: {
      showDetailText: String,
      hideDetailsText: String,
    },
    data() {
      return {
        detailsVisible: false
      };
    },
    computed: {
      translations() {
        return {
          showDetails: this.showDetailText || this.$t('Show details'),
          hideDetails: this.hideDetailsText || this.$t('Hide details')
        };
      }
    }
  };

</script>

<style lang="scss" scoped>
.details-button {
  text-decoration: none;
  color: $av-fixed-link;
  cursor: pointer;
}
</style>
